import { TypeText } from '@mui/material';

export type ListColorsType = keyof Omit<TypeText, 'disabled'>;

export enum ListColors {
  PRIMARY = 'primary',
  SECONDARY = 'secondary',
}
